'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var message_1 = require("../adapter/messages/message");
var util_1 = require("./util");
var Messages = /** @class */ (function () {
    function Messages() {
    }
    /**
     * Get messages
     */
    Messages.prototype.get = function (lang, userName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params, res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userName = util_1.getUserName('messages.get', userName);
                        params = { userName: userName, lang: lang };
                        return [4 /*yield*/, adapter_1.adapter.messages.filter(params)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.map(function (msg) { return message_1.unlocalize(msg, lang); })];
                }
            });
        });
    };
    /**
     * Archive message
     */
    Messages.prototype.archive = function (messageId, userName) {
        userName = util_1.getUserName('messages.archive', userName);
        var params = { userName: userName, messageId: messageId };
        return adapter_1.adapter.messages.archive(params);
    };
    /**
     * Mark message as checked
     */
    Messages.prototype.markAsRead = function (messageId, userName) {
        userName = util_1.getUserName('messages.markAsRead', userName);
        var params = { userName: userName, messageId: messageId };
        return adapter_1.adapter.messages.markAsRead(params);
    };
    return Messages;
}());
exports.messages = new Messages();
